import React from 'react';
import Modal from 'react-bootstrap/Modal';

export default function ModalFooterViewer(props) {
  return (
    <Modal.Footer {...props}>
      {props.children}
    </Modal.Footer>
  )
}